import React from 'react';
import { CategoriesCreateForm, CategoriesEditForm } from './CategoryFormTypes';
import {
  Form,
  ImageUploadWithCropping,
  Input,
  RequiredHelpPhrase,
  Row,
  SubmitButton,
  useForm,
} from '../../../_lib/Form2';
import { ColorChooser } from '../../../_lib/Form2/elements/ColorChooser/ColorChooser';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { HiddenInput } from '../../../_lib/Form2/elements/HiddenInput/HiddenInput';

type AddForm = { type: 'add'; form: CategoriesCreateForm };
type EditForm = { type: 'edit'; form: CategoriesEditForm };

type CategoriesAddOrEditFormProps = {
  refresh: () => void;
  closeModal: () => void;
} & (AddForm | EditForm);

export function CategoriesAddOrEditForm({ type, form, refresh, closeModal }: CategoriesAddOrEditFormProps) {
  const { t } = useSonTranslation('Categories');

  const onSuccess = () => {
    setTimeout(() => {
      closeModal();
      refresh();
    }, 2000);
  };

  const { formProps, params, fetchState } = useForm({ form, activateLeavingGuard: true, onSuccess });

  const imageUpload = params.findByName('imageuploadparams');
  const title = params.findByName('title');
  const maxValidityPeriodDays = params.findByName('maxValidityPeriodDays');
  const hexColor = params.findByName('hexColor');
  const categoryId = params.findByName('categoryId');

  return (
    <Form id="categories-add-or-edit-form" {...formProps}>
      {categoryId && <HiddenInput {...categoryId} />}
      {imageUpload ? <ImageUploadWithCropping param={imageUpload} /> : null}
      <RequiredHelpPhrase />
      {title && (
        <Row>
          <Input label={t('addOrEdit.title')} param={title} />
        </Row>
      )}
      {maxValidityPeriodDays && (
        <Row>
          <Input
            label={t('addOrEdit.validationDate')}
            helpText={t('addOrEdit.validationDateHelpText')}
            param={maxValidityPeriodDays}
          />
        </Row>
      )}
      {hexColor && <ColorChooser label={t('addOrEdit.colorChooser.title')} param={hexColor} />}

      <SubmitButton
        buttonLabel={t(`addOrEdit.submitButton.${type}`)}
        messageSuccess={t(`addOrEdit.status.${type}.success`)}
        messageSending={t('phrases:processIsCurrentlyRunningWithDots')}
        messageFail={t(`addOrEdit.status.${type}.fail`)}
        fetchState={fetchState}
        active={fetchState.type !== 'loading' && fetchState.type !== 'success'}
      />
    </Form>
  );
}
